import { render, staticRenderFns } from "./CreditScoreHistory.vue?vue&type=template&id=89b6425e&scoped=true"
import script from "./CreditScoreHistory.vue?vue&type=script&lang=ts"
export * from "./CreditScoreHistory.vue?vue&type=script&lang=ts"
import style0 from "./CreditScoreHistory.vue?vue&type=style&index=0&id=89b6425e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b6425e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VDivider,VIcon,VImg})
